;(function() {
  const defaultScrollThreshold = 50;
  const hasScrolledClsn = 'has-scrolled-header-threshold';
  const noTransitionClsn = 'no-transition';
  const scrollThresholdCcp = '--lv-header-scroll-threshold';
  const computedStyle = getComputedStyle(document.documentElement);
  const body = document.body;
  const pageHeader = body.querySelector('body > header');
  const mainNavBar = body.querySelector('.nav-top');
  const onceOptions = { once: true };

  if (pageHeader) {
    window.addEventListener('resize', () => cancelTransition(), false);
    document.addEventListener('scroll', () => onScroll(), false);
  }

  /**
   * Cancel transition.
   */
  function cancelTransition() {
    updateTransitionEventHandlers(true);
    body.classList.add(noTransitionClsn);
    window.requestAnimationFrame(() => dispatchRepad());
  }

  /**
   * Trigger Equinoxe's repadding callback.
   */
  function dispatchRepad() {
    document.body.dispatchEvent(new CustomEvent('repad'));
    body.classList.remove(noTransitionClsn);
    updateTransitionEventHandlers(false);
  }

  /**
   * Handle scrolling.
   */
  function onScroll() {
    const scrollThreshold = computedStyle.getPropertyValue(scrollThresholdCcp);

    body.classList.toggle(
      hasScrolledClsn,
      window.scrollY > (scrollThreshold !== '' ? scrollThreshold : defaultScrollThreshold),
    );
  }

  /**
   * @param {boolean} [add = false] - Whether to add or remove the event listeners
   */
  function updateTransitionEventHandlers(add = false) {
    const method = add ? 'addEventListener' : 'removeEventListener';

    pageHeader[method]('transitioncancel', () => dispatchRepad(), onceOptions);
    pageHeader[method]('transitionend', () => dispatchRepad(), onceOptions);
    if (mainNavBar) {
      mainNavBar[method]('transitioncancel', () => dispatchRepad(), onceOptions);
      mainNavBar[method]('transitionend', () => dispatchRepad(), onceOptions);
    }
  }
}());
